import React from 'react';
import { formatMilitaryTime } from './helpers/cellFormatters';

const MilitaryTime = ({ params }) => {
    const value = params?.value;

    if (value == null || value === '') {
        return <></>;
    }

    return <span>{formatMilitaryTime(value)}</span>;
};

export default MilitaryTime;
